import { Link } from "react-router-dom";
import { MapPin, Building2, ArrowUpRight, ImageOff, Phone, MessageCircle } from "lucide-react";
import { Tilt } from "./Motion";
import { formatPrice, imgSources } from "@/lib/api";
import { oppTypeLabel, CONTACT_PHONE } from "@/lib/constants";

export function OpportunityCard({ o, categoryName, detailsLabel = "Scopri di più" }) {
  const photo = o.photos?.[0];
  const img = photo ? imgSources(photo.path, photo.path_sm) : null;
  return (
    <Tilt max={4} className="group h-full rounded-2xl">
      <article data-testid={`opportunity-card-${o.slug}`} className="chrome panel flex h-full flex-col overflow-hidden rounded-2xl">
        <div className="relative aspect-[4/3] overflow-hidden bg-[var(--antracite)]">
          {img ? (
            <img src={img.src} srcSet={img.srcSet} sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw" alt={photo.alt || o.title} loading="lazy" decoding="async" className="zoom-img h-full w-full object-cover" />
          ) : (
            <div className="flex h-full flex-col items-center justify-center gap-3 p-6">
              <img src="/img/casace-logo-400.webp" alt="Casa C'è" className="w-3/4 rounded-lg" loading="lazy" />
              <span className="flex items-center gap-1.5 text-xs muted"><ImageOff size={13} />Fotografie in arrivo</span>
            </div>
          )}
          <div className="absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-[#080A12] to-transparent" />
          <div className="absolute left-3 top-3 flex flex-wrap gap-2">
            {o.number && <span className="pill bg-[var(--rosso)] text-sm text-white" data-testid={`opportunity-number-${o.slug}`}>N. {o.number}</span>}
            {o.badge_label ? <span className="pill bg-[var(--blu)] text-white">{o.badge_label}</span> : categoryName && <span className="pill bg-[var(--nero)]/80 text-white backdrop-blur">{categoryName}</span>}
          </div>
        </div>
        <div className="flex flex-1 flex-col p-5">
          <p className="flex items-center gap-1.5 text-xs muted"><MapPin size={13} className="text-[var(--rosso)]" />{[o.area, o.city, o.province && `(${o.province})`].filter(Boolean).join(" · ")}</p>
          <h3 className="mt-2 text-lg font-semibold uppercase leading-snug text-white">{o.title}</h3>
          {o.summary && <p className="mt-2 line-clamp-3 text-sm muted">{o.summary}</p>}
          <p className="mt-4 font-display text-xl font-bold text-white" data-testid={`opportunity-price-${o.slug}`}>{formatPrice(o)}</p>
          {!o.badge_label && !o.number && <p className="mt-1 text-xs muted">{oppTypeLabel(o.opportunity_type)}</p>}
          {o.partner_name && <p className="mt-2 flex items-center gap-1.5 text-xs muted"><Building2 size={13} />Proposta da {o.partner_name}</p>}
          <div className="mt-auto flex flex-col gap-2 pt-5 sm:flex-row">
            <Link to={`/opportunita/${o.slug}`} className="btn btn-ghost btn-sm flex-1 uppercase" data-testid={`opportunity-details-btn-${o.slug}`}>{o.cta_label || detailsLabel}<ArrowUpRight size={14} /></Link>
            <Link to={`/opportunita/${o.slug}#richiedi-informazioni`} className="btn btn-red btn-sm flex-1" data-testid={`opportunity-info-btn-${o.slug}`}>RICHIEDI INFORMAZIONI</Link>
          </div>
          <p className="mt-3 text-center text-xs muted">Per maggiori informazioni: <a href={`tel:${CONTACT_PHONE.tel}`} className="font-semibold text-white">{CONTACT_PHONE.label}</a></p>
          <div className="mt-2 grid grid-cols-2 gap-2">
            <a href={`tel:${CONTACT_PHONE.tel}`} className="btn btn-blue btn-sm" data-testid={`opportunity-call-${o.slug}`}><Phone size={13} />CHIAMA ORA</a>
            <a href={CONTACT_PHONE.wa} target="_blank" rel="noopener noreferrer" className="btn btn-sm bg-[#25D366] text-white hover:brightness-110" data-testid={`opportunity-whatsapp-${o.slug}`}><MessageCircle size={13} />WHATSAPP</a>
          </div>
        </div>
      </article>
    </Tilt>
  );
}
